import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/OptionsMenu/options-menu';
import { css } from '@patternfly/react-styles';
import { fillTemplate } from '../../helpers';
import { DropdownToggle } from '../Dropdown';
var toggleId = 0;
export var OptionsToggle = function OptionsToggle(_ref) {
  var _ref$itemsTitle = _ref.itemsTitle,
      itemsTitle = _ref$itemsTitle === void 0 ? 'items' : _ref$itemsTitle,
      _ref$optionsToggle = _ref.optionsToggle,
      optionsToggle = _ref$optionsToggle === void 0 ? 'Select' : _ref$optionsToggle,
      _ref$itemsPerPageTitl = _ref.itemsPerPageTitle,
      itemsPerPageTitle = _ref$itemsPerPageTitl === void 0 ? 'Items per page' : _ref$itemsPerPageTitl,
      _ref$firstIndex = _ref.firstIndex,
      firstIndex = _ref$firstIndex === void 0 ? 0 : _ref$firstIndex,
      _ref$lastIndex = _ref.lastIndex,
      lastIndex = _ref$lastIndex === void 0 ? 0 : _ref$lastIndex,
      _ref$itemCount = _ref.itemCount,
      itemCount = _ref$itemCount === void 0 ? 0 : _ref$itemCount,
      _ref$widgetId = _ref.widgetId,
      widgetId = _ref$widgetId === void 0 ? '' : _ref$widgetId,
      _ref$showToggle = _ref.showToggle,
      showToggle = _ref$showToggle === void 0 ? true : _ref$showToggle,
      _ref$onToggle = _ref.onToggle,
      onToggle = _ref$onToggle === void 0 ? function (_isOpen) {
    return undefined;
  } : _ref$onToggle,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$parentRef = _ref.parentRef,
      parentRef = _ref$parentRef === void 0 ? null : _ref$parentRef,
      _ref$toggleTemplate = _ref.toggleTemplate,
      ToggleTemplate = _ref$toggleTemplate === void 0 ? '' : _ref$toggleTemplate,
      _ref$onEnter = _ref.onEnter,
      onEnter = _ref$onEnter === void 0 ? null : _ref$onEnter;
  return React.createElement("div", {
    className: css(styles.optionsMenuToggle, isDisabled && styles.modifiers.disabled, styles.modifiers.plain, styles.modifiers.text)
  }, showToggle && React.createElement(React.Fragment, null, React.createElement("span", {
    className: css(styles.optionsMenuToggleText)
  }, typeof ToggleTemplate === 'string' ? fillTemplate(ToggleTemplate, {
    firstIndex: firstIndex,
    lastIndex: lastIndex,
    itemCount: itemCount,
    itemsTitle: itemsTitle
  }) : React.createElement(ToggleTemplate, {
    firstIndex: firstIndex,
    lastIndex: lastIndex,
    itemCount: itemCount,
    itemsTitle: itemsTitle
  })), React.createElement(DropdownToggle, {
    onEnter: onEnter,
    "aria-label": optionsToggle,
    onToggle: onToggle,
    isDisabled: isDisabled || itemCount <= 0,
    isOpen: isOpen,
    id: "".concat(widgetId, "-toggle-").concat(toggleId++),
    className: styles.optionsMenuToggleButton,
    parentRef: parentRef
  })));
};